import React from 'react'
import styled from 'styled-components'

const SideBarBtn = ({ title, icon, selectedIcon, selected, containertStyle, onClick }) => {

    return (
        <Container style={containertStyle} onClick={onClick}>
            <IconWrapper selected={selected}>
                {selected ? selectedIcon : icon}
            </IconWrapper >
            <Title selected={selected}>{title}</Title>
            {selected && <SelectedBorder />}
        </Container>
    )
}

export default SideBarBtn

const Container = styled.div`
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;
cursor:pointer;
gap:6px;
position:relative;
`
const IconWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
width:35px;
height:35px;
border-radius:4px;
background:${({ selected, theme }) => selected ? theme.sidebar.selectedBtnBackground : "transparent"};
color:${({ selected, theme }) => selected ? theme.sidebar.selectedIconColor : theme.sidebar.iconColor};
`
const Title = styled.p`
font-weight: 600;
font-size: 12px;
line-height: 14px;
letter-spacing: 0.04px;
text-align: center;
vertical-align: middle;
word-wrap: break-word;
margin: 0;
color:${({ selected, theme }) => selected ? theme.sidebar.selectedBtnTextColor : theme.menu.secondaryTextColor};
`
const SelectedBorder = styled.div`
height:35px;
width:5px;
border-radius:2px;
background:${({ theme }) => theme.menu.selectedTextColor};
top:0px;
left:-10px;
position:absolute;
`